import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml', pure: true })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) { }
  transform(value: any, isHtmlSanitized?: boolean) {
    if (isHtmlSanitized) {
      return this.sanitized.bypassSecurityTrustHtml(value);
    } else {
      return this.sanitized.sanitize(SecurityContext.HTML, this.sanitized.bypassSecurityTrustHtml(value));
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/common/pipes/safe-html.pipe.ts